import React, { useState } from 'react';
import { Header, Main, Nav, NavBtns, Scrollup, Navclose, NavItem, NavLink, NavList, NavLogo, NavMenu, NavToggle } from './HomeStyles';
import { UilEstate, UilUser, UilArrowUp, UilFileAlt,UilBrightness, UilMoon, UilApps, UilBriefcaseAlt, UilScenery, UilMessage, UilTimes } from '@iconscout/react-unicons';
import HomeSection from '../homeSection/HomeSection';
import About from '../about/About';
import Skills from '../skills/Skills';
import Qualification from '../qualification/Qualification';
import Services from '../services/Services';
import Portfolio from '../portfolio/Portfolio';
import Project from '../project/Project';
import Testimonials from '../testimonials/Testimonials';
import Contact from '../contact/Contact';
import Footer from '../footer/Footer';
import { animateScroll as ScrollUp } from "react-scroll";


function Home({ setTheme, theme }) {
    const [isScrolled, setIsScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    //make changes to styles on vertical scroll
    window.onscroll = () => {
        setIsScrolled(window.pageYOffset === 0 ? false : true);
        return () => (window.onscroll = null);
    };

    const navData = [
        { icon: <UilEstate className="nav-icon" size="1.25rem" />, to: "home-section", name: "Home" },
        { icon: <UilUser className="nav-icon" size="1.25rem" />, to: "about-section", name: "About" },
        { icon: <UilFileAlt className="nav-icon" size="1.25rem" />, to: "skills-section", name: "Skills" },
        { icon: <UilBriefcaseAlt className="nav-icon" size="1.25rem" />, to: "services-section", name: "Services" },
        { icon: <UilScenery className="nav-icon" size="1.25rem" />, to: "portfolio-section", name: "Portfolio" },
        { icon: <UilMessage className="nav-icon" size="1.25rem" />, to: "contact-section", name: "Contactme" },
    ];
    
    const Toggle = () => {
        setOpen(!open);
    }

    return (
        <>
            <Header isScrolled={isScrolled}>
                <Nav>
                    <NavLogo>Oji</NavLogo>

                    <NavMenu open={open}>
                        <NavList>
                            {
                                navData.map((data, index) => (
                                    <NavItem key={index}>
                                        <NavLink
                                            to={data.to}
                                            onClick={Toggle}
                                            activeClass="active"
                                            spy={true}
                                            smooth={true}
                                            offset={30}
                                            duration={300}
                                            hashSpy={true}>
                                            {data.icon} {data.name}
                                        </NavLink>
                                    </NavItem>
                                ))
                            }
                        </NavList>

                        <Navclose onClick={Toggle} />
                    </NavMenu>

                    <NavBtns>
                        {/* theme change button */}
                        {
                            theme.mode === 'dark'
                            ?<UilBrightness
                                size="1.25rem"
                                className="change-theme"
                                onClick={()=>setTheme({mode: 'light'})}/>

                            :<UilMoon 
                                size="1.25rem"
                                className="change-theme"
                                onClick={()=>setTheme({mode: 'dark'})} />
                        }
                        {/* nav toggle button */}
                        <NavToggle onClick={Toggle}>
                            <UilApps />
                        </NavToggle>
                    </NavBtns>
                </Nav>
            </Header>
            <Main>
                <HomeSection />
                <About />
                <Skills />
                <Qualification />
                <Services />
                <Portfolio />
                <Project />
                {/* <Testimonials/> */}
                <Contact />
                <Footer />
            </Main>
            {/* scroll to top of the page */}
            <Scrollup
                to="#"
                scrolled={isScrolled}
                onClick={() => ScrollUp.scrollToTop()}
            >
                <UilArrowUp size="2rem" className="scroll__icon" />
            </Scrollup>
        </>
    )
}

export default Home